import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ProductiveCycleStageTemplateForm from '../Forms/ProductiveCycleStageTemplateForm';

const AddEditProductiveCycleModal = ({
	dataProductiveCycleStageTemplate,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Etapa del Ciclo Productivo
			</ModalHeader>

			<ProductiveCycleStageTemplateForm
				dataProductiveCycleStageTemplate={dataProductiveCycleStageTemplate}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditProductiveCycleModal;
